export const GET_ACCESS_BY_USER_REQUEST = 'GET_ACCESS_BY_USER_REQUEST'
export const GET_ACCESS_BY_USER_SUCCESS = 'GET_ACCESS_BY_USER_SUCCESS'
export const GET_ACCESS_BY_USER_FAIL = 'GET_ACCESS_BY_USER_FAIL'

export const ADD_ACCESS_BY_USER_REQUEST = 'ADD_ACCESS_BY_USER_REQUEST'
export const ADD_ACCESS_BY_USER_SUCCESS = 'ADD_ACCESS_BY_USER_SUCCESS'
export const ADD_ACCESS_BY_USER_FAIL = 'ADD_ACCESS_BY_USER_FAIL'
